<template>
  <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)">
      <div class="form-group row mt-4">
        <reg-input-text
          v-if="fields[0]"
          label="Email Address"
          type="email"
          :form="form"
          :field="fields[0]"
          placeholder="Enter Email Address"
        
          formGroupClass="col-xxl-12 mb-2"
          :rules="{ required: fields[0].required, email: true }"
        />
          <!-- :api-errors="apiErrors"  this is for showing field error-->
        
         <span v-if="showOtpSectionEmail" class="validate-btn col-md-5 col-sm-6 d-flex rep-reg-otp-validation mb-2" style="margin-left: 3px;">
                  <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('email')" >
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL. 
                  </a>
                </span>
      </div>
      <!-- <button
       @click="openModal(fields[0].field_name)"
        class="button-verify-email"
        v-if="apiErrors && apiErrors[fields[0].field_name]"
      >
        Verify Your Email
      </button> -->




                <!-- show the message -->

                   <div v-if="emailMsg" class="contact-message-container form-group">
          <div :class="['validate-message mt-2', emailValidationMessage.type]">
            <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
              {{ emailValidationMessage.message }}
            </span>
          </div>
        </div>

      <div class="d-flex align-items-center mb-3 mt-4">
        <input type="checkbox" class="mb-1" v-model="isChecked" />
        <label class="mb-0 ms-2">Display Email Address</label>
      </div>
      <!-- additional email  -->
      <div class="form-group row mt-2" v-if="isChecked">
        <reg-input-text
          v-if="fields[3]"
          label="Display Email Address"
          type="email"
          :form="form"
          :field="fields[3]"
          placeholder="Enter New Email Address"
          formGroupClass="col-xxl-12 mb-2"
        />

   <span v-if="showOtpSectionDisplayEmail" class="validate-btn col-md-5 col-sm-6 d-flex " style="margin-left: 3px;">
                  <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('display_email')">
                      Validate via OTP
                  </a>
                </span>
  <div v-if="dispalyEmailMsg" class="contact-message-container form-group">
          <div :class="['validate-message mt-2', displayEmailValidationMessage.type]">
            <div :class="['message-indicator', `${displayEmailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${displayEmailValidationMessage.type}-text`">{{ displayEmailValidationMessage.title }}</strong> - 
              {{ displayEmailValidationMessage.message }}
            </span>
          </div>
        </div>

      </div>

      <div class="form-group row">
        <reg-input-text
          v-if="fields[1]"
          label="Password"
          type="password"
          :form="form"
          :field="fields[1]"
          placeholder="Password"
          formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
          :rules="{ required: fields[1].required }"
        >
        <!--           :api-errors="apiErrors" -->


          <template v-slot:appendIcon>
            <eye-button
              id="password"
              class-name="toggle-password-icon"
              :hide-on-default="true"
              type="password"
            />
          </template>
          <template v-slot:shortMessage>
            <span
              class="short-msg"
              v-if="!(apiErrors && apiErrors[fields[1].field_name])"
            >
            Password should be at least 8 characters long and include uppercase, lowercase, number & special character.
            and One Special Character
            </span>
     

          </template>
        </reg-input-text>

        <reg-input-text
          v-if="fields[2]"
          label="Confirm Password"
          type="password"
          :form="form"
          :field="fields[2]"
          placeholder="Confirm Password"
          :api-errors="apiErrors"
          formGroupClass="col-xxl-6 col-xl-6 col-lg-6 col-md-6 mb-4"
          :rules="{ required: fields[2].required }"
        >
          <template v-slot:appendIcon>
            <eye-button
              id="password_confirmation"
              class-name="toggle-password-icon"
              :hide-on-default="true"
              type="password"
            />
          </template>
        </reg-input-text>

                         <div v-if="passwordMsg" class="contact-message-container form-group">
          <div :class="['validate-message', passwordValidationMessage.type]">
            <div :class="['message-indicator', `${passwordValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${passwordValidationMessage.type}-text`">{{ passwordValidationMessage.title }}</strong> - 
              {{ passwordValidationMessage.message }}
            </span>
          </div>
        </div>
      </div>
      <div class="action-btn split-action mt-5">
        <button type="button" class="button-back" @click="backHandler">Back</button>
        <div class="action-next">
          <button class="button-save" @click.prevent="saveAndContinue" type="button">
            Save & Continue Later
          </button>
          <button class="button-submit" type="submit">Next</button>
        </div>
      </div>
    </form>
    <!-- <verify-phone-email-modal /> -->

 <RegistrationOTPModal
    v-if="showOtpModal"
    v-model="showOtpModal"
    :identifier="contactInfo"
    :identifierTypeText="otpType"
    :field="field"
    @save="handleVerificationResult"
    @close="closeOtpModal"
/>

  </ValidationObserver>
</template>
<script>
import Api from "@/resource/Api";
import Cookies from "js-cookie";

// import NewLoginOTP from "@/components/ui/NewLoginOTP.vue";

import axios from "@/utils/regAxios";
import ScreenShot from "@/utils/screenshot";
// import VerifyPhoneEmailModal from "../../MemberList/modal/VerifyPhoneEmailModal.vue";
import RegistrationOTPModal from "../modal/RegistrationOTPModal.vue";

export default {
  name: "LoginForm",
  components: {
    // VerifyPhoneEmailModal,
    RegistrationOTPModal,
    
  },
  props: {
    fields: {
      required: true,
    },
    form: {
      required: true,
    },
  },
  data: () => ({

    apiErrors: null,
    isChecked: false,
    showOtpModal: false,
    contactInfo: null,
    otpType: null,
    emailMsg: false,
    phoneMsg: false,
    emailValidationMessage: null,
    phoneValidationMessage: null,
    validationStatus: null,
    showOtpSectionEmail: false,
    showOtpSectionPhone: false,
    skipEmailVerification: false,

    skipPhoneVerification: false,
    emailVerified: false,
    phoneVerified: false,
    showOtpSectionDisplayEmail: false,
    dispalyEmailMsg: false,
    displayEmailValidationMessage: null,
    passwordMsg:false,
    passwordValidationMessage:null,
    field:null,
    
  }),
  methods: {

     removeTimer() {
   Cookies.remove("otp_logged_time");
 },
  

    checkCookies(){
if (Cookies.get('otp_logged_time') !== undefined) {
  return true
} 
else {

  return false
}
    },


getTimer(){

  if(this.checkCookies()){
    // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
    return false
  }

let cookieValue =Cookies.get('otp_logged_time')
        let remaining = Math.round(
            (cookieValue - new Date().getTime()) / 1000
        );
   this.remaningSecond = isNaN(remaining) ? 0 : remaining;

if(remaining){
  // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
  return false
}
else{

  return true
}

},
 resetValidationState() {
      this.validationStatus = null;
      this.emailValidationMessage = null;
      this.phoneValidationMessage = null;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.skipEmailVerification = false;
      this.skipPhoneVerification = false;
      this.emailVerified = false;
      this.phoneVerified = false;
    },

   handleVerificationResult(result) {
  if (result.verified) {
    // Handle successful verification
    if (result.type === 'email' && result.field === 'email') {
      this.emailmsg = true;
      this.emailVerified = true;
      this.emailValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Your email has been verified!'
      };
      this.skipEmailVerification = true;
      this.showOtpSectionEmail = false;
    }
     else if(result.type==='email' && result.field==='display_email') {
      this.displayEmailMsg = true;
      this.displayEmailValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Your email has been verified!'
      };
      this.showOtpSectionDisplayEmail = false;
    }

    this.$notify('Verification successful!');
  } else if (result.skipped) {
    // Handle skipped verification
    if (result.type === 'email' && result.field === 'email') {
      this.skipEmailVerification = true;
      this.emailMsg = true;
      this.emailValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Email verification was skipped'
      };
      this.showOtpSectionEmail = false;
    }
    
    else if(result.type==='email' && result.field==='display_email') {
      this.displayEmailMsg = true;
      this.displayEmailValidationMessage = {
        type: 'success',
        title: 'Success',
        message: 'Email verification was skipped!'
      };
      this.showOtpSectionDisplayEmail = false;
    }

    this.$notify('Verification skipped', 'warning');
  }
},

  // method to send the otp
  async sendOtp() {

    if(!this.getTimer()){
  // this.$notify('Please wait for 10 minutes before sending another OTP', 'error')
  return
} 

      try {
        const response = await Api.post('v2/send-rep-otp', {
          contact: this.contactInfo,
          enrollment_id: this.$store.getters.regTempId,

          type: this.otpType,

        });
        
        if (response.data.success === true || response.data.status === 'success') {
      this.$notify('OTP sent successfully!');
    } else {
      this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
      // this.showOtpSection = false;
    }
      } catch (error) {
        this.$notify('Failed to send OTP. Please try again.', 'error');
        // this.showOtpSection = false;
        console.error('OTP send error:', error);
      }
    },

    
    openOtpModal(type) {
      if (type === "email" && !this.form.email) {
        this.$notify("Please enter an email address first.", "warning");
        return;
      }

      if (type === "phone" && !this.form.cell_phone) {
        this.$notify("Please enter a Phone number first.", "warning");
        return;
      }
      if (type === "display_email" && !this.form.display_email) {
        this.$notify("Please enter a display email address first.", "warning");
        return;
      }

   

      if(type==="email"){
        this.field="email";
        this.contactInfo=this.form.email;
        this.otpType = type;
     this.sendOtp();

      }

      if(type==="display_email"){
        this.field="display_email"
        this.contactInfo=this.form.display_email;
        this.otpType = 'email';
      this.sendOtp();
      }
      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      this.showOtpModal = true;
      
    },


    // to close the otp modal
        closeOtpModal() {

      this.showOtpModal = false;
    },
    
    saveAndContinue() {
      this.$emit("onOpenSaveAndContinue", this.form);
    },


    
    backHandler() {
      this.$emit("onBackLoginInfoForm");
    },
    submit() {

          this.passwordMsg = false;
      this.passwordValidationMessage = null;
      if (this.isChecked && this.form.display_email) {
        this.fields[4].value = this.form.display_email;
        this.form.is_displayEmail = true;
      } else {
        this.form.display_email = "";
        this.form.is_displayEmail = false;
        this.isChecked = false;
      }
      this.form.registration_id = this.$store.getters.regTempId;
      this.form.savecont = false;
      let loader = this.$loading.show();
      let formData = this.form;
      ScreenShot.captureScreenShot(ScreenShot.regScreenShotSelector)
        .then((res) => {
          if (res) {
            formData["screenshot"] = res;
          }
        })
        .finally(() => {
          loader.hide();
          const url = "v2/registration/login-info";
          this.save(url, formData);
        });
    },

    save(url, payload) {
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;
      this.emailMsg = false;
      this.phoneMsg = false;
      this.dispalyEmailMsg = false;
      this.showOtpSectionDisplayEmail = false;
      
      payload.skip_validation_email = this.skipEmailVerification;

      let loader = this.$loading.show();
      axios
        .post(url, payload)
        .then(() => {
          this.$emit("onSuccessLoginInfoForm");
              this.removeTimer();

        })
        .catch((err) => {
          this.removeTimer();
          if (err.response.data.statusCode == 422) {
            this.apiErrors = err.response.data.errors;
            // this.$notify(this.apiErrors.email, "error");

            if(this.apiErrors.email) {
              let notificationMessage = '';
              this.emailMsg = true;
              if(this.apiErrors.email.includes("Email Already Exists.")){
                notificationMessage = 'Email is already in use';
              } else {
                this.showOtpSectionEmail = true;
                notificationMessage = 'Invalid Email - Please validate via OTP';
              }
              this.emailValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: notificationMessage
              };
              // this.$notify("Invalid Email - Please validate via OTP", "error");
            }

            if(this.apiErrors.password){
              this.passwordMsg=true
              this.passwordValidationMessage={
                type:'error',
                title:'Error',
                message:this.apiErrors.password[0],
              }
            }

            if(this.apiErrors.display_email){
              this.dispalyEmailMsg = true;
              // this.showOtpSectionDisplayEmail = true;
              this.displayEmailValidationMessage = {
                type: 'error',
                title: 'Caution',
                message: 'Invalid Email - Please enter valid display email',
              };
            }
              this.$notify("Please enter the valid details", "error");


            // setTimeout(() => {
            //   if (this.apiErrors && this.fields && this.fields.length > 0) {
            //     const fieldsToKeep = [
            //       this.fields[0].field_name, 
            //       this.fields[3].field_name, 
            //     ];

            //     const newErrors = { ...this.apiErrors };

            //     // Remove errors for all fields except fields[0] and fields[3]
            //     Object.keys(newErrors).forEach((key) => {
            //       if (!fieldsToKeep.includes(key)) {
            //         delete newErrors[key];
            //       }
            //     });

            //     this.apiErrors = Object.keys(newErrors).length
            //       ? newErrors
            //       : null;
            //   }
            // }, 5000);
          } else {
            this.$notify(err.response.data.message, "error");
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  watch: {
    fields: {
      handler(newFields) {
        const isDisplayEmailField = newFields.find(
          (field) => field.field_name === "is_displayEmail"
        );
        if (isDisplayEmailField) {
          this.isChecked = isDisplayEmailField.value === true;
        }
      },
      deep: true,
      immediate: true,
    },

     'form.email': {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.removeTimer('email');
        this.skipEmailVerification = false;
        this.emailMsg = false;
        this.emailValidationMessage = null;
        this.showOtpSectionEmail = false;
        this.emailVerified = false;
        

      }
    },
    immediate: true
  },
  },
  created() {
        this.removeTimer();

    if (!this.$store.getters.regTempId) {
      this.backHandler();
    }
  },
};
</script>

<style scoped>

.form-group {
  margin-bottom: 0.5rem;
}
.validate-via-otp-link{
  color: #03c3ec;
}
.validate-message {
  display: flex;
  align-items: center;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem 1rem;
  position: relative;
  margin-bottom: 0.75rem;
}

.message-indicator {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.message-text {
  flex-grow: 1;
  margin-left: 0.5rem;
  color: #495057;
}

.error-text {
  color: #dc3545;
  font-size: 0.875rem !important;
}

.success-text {
  color: #28a745;
}

.warning-text {
  color: #856404;
}

.error-indicator {
  background-color: #dc3545;
}

.success-indicator {
  background-color: #28a745;
}

.warning-indicator {
  background-color: #ffc107;
}

.button-verify-email {
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 16px;
  border: none;
  background-color: transparent;
  color: rgb(5, 5, 139);
  text-decoration: underline;
  text-align: start;
}

.rep-reg-otp-validation {
    border: 2px solid #e31717;
    max-width: 420px;
    margin-left: 12px !important;
    padding: 5px;
    padding-left: 22px;
  }

.rep-reg-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
</style>
